import React from 'react';
import Checkbox from '../../ui/checkbox';
import RadioButton from '../../ui/radiobutton';

import './../style/fonts.module.css'

const Answer = ({ onChange, index, choice, type, selectedAnswer }) => {
  // Convert index to alphabet character to show 'abcd' before question
  const label = String.fromCharCode(97 + index);

  return (
    <div
      className={`text-secondary mt-[clamp(13px,calc(10px+6*((100vw-600px)/1320)),16px)] cursor-pointer border-b text-[clamp(18px,4vw,16px)] ${
        selectedAnswer.includes(choice) 
          ? 'border-[#FF8036] border-2 rounded-md bg-white font-semibold shadow-md transition-all duration-300 ease-in-out' 
          : 'border-gray-200'
      }`}
    >
      <label className="grid cursor-pointer grid-cols-[min-content_min-content_auto] gap-2 p-4 text-lg">
        {type === 'QCM' ? (
          <Checkbox
            name={choice.value}
            checked={selectedAnswer.includes(choice.value)}
            handleChange={onChange}
          />
        ) : (
          <RadioButton
            name={choice.value}
            value={choice.value}
            checked={selectedAnswer.includes(choice.value)}
            onChange={onChange}
          />
        )}
        <span>{label}&#41;</span>
        {choice.value}
      </label>
    </div>
  );
};

export default Answer;